export default __webpack_public_path__ + "static/smp-light-text_2-e467597c9cf92bc4689d2ed891a2d8fb.webp";